import React, { Component } from 'react';
import "./MapHeader.scss";
import { pins } from "../App/filters"

export default class MapHeader extends Component {
  render() {
    return (
      <section className="section section-mapheader">
        <div className="padding">
          <div className="container">
            <div className="headline">
              {/* <div className="head">
                דרך קיצור
              </div> */}
              <div className="desc">
                המפה שתבחר לכם אטרקציות לחג בהתאמה אישית
            </div>
            </div>
          </div>
          <div className="line"></div>
          <div className="mlabel">
            ביחרו פעילות:
          </div>
          <div className="pins">
            <div className="sides">
              <div className="label">
                ביחרו פעילות:
              </div>
              {(() => pins.map((item, index) => <div
                onClick={() => {
                  this.props.setFilter(item.filter);
                }}
                key={index} className={`pin ${item.filter != this.props.currentFilter && this.props.currentFilter != "" ? "" : this.props.currentFilter == "" ? "show": "off"} pin-${item.image}`}>
                <div className="image"></div>
                <div className="text">{item.label}</div>
              </div>))()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Components/MapHeader/MapHeader.jsx